/*
 * Hook that calls POST /import/validate whenever the input tuples change.
 *
 * Returns { loading, result, error } where result is the backend payload:
 *   { valid, errors, warnings, summary }
 *
 * Skips the call entirely if `enabled` is false (e.g. local parse had errors,
 * no point asking the backend to validate known-broken data).
 */

import { useEffect, useRef, useState } from 'react';
import axios from 'axios'; // swap for your project's HTTP client if different

const useBackendValidation = (tuples, enabled) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const requestIdRef = useRef(0);

    useEffect(() => {
        if (!enabled || !tuples || !tuples.length) {
            setResult(null);
            setError(null);
            setLoading(false);
            return;
        }

        const requestId = ++requestIdRef.current;
        setLoading(true);
        setError(null);

        axios
            .post('/import/validate', { tuples })
            .then((res) => {
                if (requestId !== requestIdRef.current) return; // stale
                setResult(res.data);
                setLoading(false);
            })
            .catch((err) => {
                if (requestId !== requestIdRef.current) return;
                setError(err?.response?.data?.error || err.message || 'Validation failed');
                setLoading(false);
            });
    }, [tuples, enabled]);

    return { loading, result, error };
};

export default useBackendValidation;